import React, { useEffect, useState } from "react";
import $ from "jquery";
import { Form } from "react-bootstrap";
import {
    addTvApkBanner,
    updateTvApkBanner,
    deleteTvApkBanner
} from "../../../../../Services/TvApksService/TvApkService";
import { toast } from 'react-toastify';

import {
    getEnvUrl,
    getToken
} from "../../../../../utils/Api";

const TvApkBanners = ({ tvApkId }) => {

    const [banners, setBanners] = useState([]);
    const [errors, setErrors] = useState({
        banner: ""
    });
    const [loading, setLoading] = useState(false);

    const [showModal, setShowModal] = useState(false);

    const [editId, setEditId] = useState(null);

    const [preview, setPreview] = useState("");
    const [imageVersion, setImageVersion] = useState(Date.now());
    const [formData, setFormData] = useState({
        title: "",
        sort_order: 0,
        banner: null
    });

    useEffect(() => {

        if (tvApkId) {
            fetchBanners();
        }

    }, [tvApkId]);

    const fetchBanners = () => {

        setLoading(true);

        return new Promise((resolve, reject) => {

            $.ajax({

                url: `${getEnvUrl()}/admin/tvapk/getBanners`,
                type: "GET",

                headers: {
                    Authorization: `Bearer ${getToken()}`
                },

                data: {
                    tv_apk_id: tvApkId
                },

                success: function (response) {

                    if (response.status) {
                        setBanners(response.data || []);
                    } else {
                        setBanners([]);
                    }

                    resolve(response);

                },

                error: function (error) {

                    console.error(error);

                    reject(error);

                },

                complete: function () {

                    setLoading(false);

                }

            });

        });

    };

    const handleChange = (e) => {

        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));

    };

    const handleFileChange = (e) => {

        const file = e.target.files[0];

        if (!file) return;

        if (!file.type.startsWith("image/")) {

            setErrors({
                banner: "Please select a valid image file."
            });

            e.target.value = "";

            return;
        }

        setErrors({
            banner: ""
        });

        setFormData((prev) => ({
            ...prev,
            banner: file
        }));

        setPreview(URL.createObjectURL(file));

    };

    const resetForm = () => {

        setErrors({
            banner: ""
        });

        setEditId(null);

        setPreview("");

        setFormData({
            title: "",
            sort_order: 0,
            banner: null
        });

        setShowModal(false);

    };

    const handleSubmit = async () => {

        try {

            setLoading(true);

            const payload = new FormData();

            payload.append("tv_apk_id", tvApkId);
            payload.append("title", formData.title);
            payload.append("sort_order", formData.sort_order);

            if (formData.banner) {
                payload.append("banner", formData.banner);
            }

            if (editId) {

                payload.append("banner_id", editId);

                await updateTvApkBanner(payload);

                toast.success("Banner Updated successfully")

            } else {

                await addTvApkBanner(payload);

                toast.success("Banner Added successfully")

            }

            // Wait until the latest data is fetched
            await fetchBanners();
            setImageVersion(Date.now());

            // Close the modal after the table is refreshed
            resetForm();

        } catch (error) {

            console.error(error);

            alert("Failed to save banner");

        } finally {

            setLoading(false);

        }

    };

    const handleEdit = (banner) => {

        setEditId(banner.id);

        setPreview(banner.banner_url);

        setFormData({
            title: banner.title || "",
            sort_order:
                banner.sort_order || 0,
            banner: null
        });

        setShowModal(true);

    };

    const handleDelete = async (bannerId) => {

        let confirmDelete = window.confirm(
            "Are you sure you want to delete this banner?"
        );

        if (!confirmDelete) return;

        try {

            await deleteTvApkBanner(bannerId);

            fetchBanners();

        } catch (error) {

            console.error(error);

        }

    };

    return (

        <div
            style={{
                background: "#ffffff",
                border: "1px solid #e2e8f0",
                borderRadius: "16px"
            }}
        >

            {/* Header */}

            <div
                className="d-flex justify-content-between align-items-center flex-wrap gap-3"
                style={{
                    padding: "20px 24px",
                    borderBottom: "1px solid #e2e8f0"
                }}
            >

                <div>

                    <h5
                        className="mb-1 fw-semibold"
                        style={{
                            color: "#0f172a"
                        }}
                    >
                        TV APK Banners
                    </h5>

                    <p
                        className="mb-0"
                        style={{
                            color: "#64748b",
                            fontSize: "14px"
                        }}
                    >
                        Manage promotional banners
                    </p>

                </div>

                {/* <button
                    className="btn"
                    onClick={() => {
                        resetForm();
                        setShowModal(true);
                    }}
                    style={{
                        background: "#0f172a",
                        color: "#ffffff",
                        borderRadius: "10px",
                        padding: "10px 18px",
                        fontWeight: "500"
                    }}
                >

                    <i className="bi bi-plus-lg me-2"></i>

                    Add Banner

                </button> */}

            </div>

            {/* Table */}

            <div className="table-responsive">
                <table className="table align-middle mb-0">

                    <thead style={{ background: "#f8fafc" }}>
                        <tr>
                            <th
                                style={{
                                    padding: "16px 24px",
                                    fontSize: "12px",
                                    fontWeight: "600",
                                    color: "#64748b",
                                    width: "30%"
                                }}
                            >
                                BANNER NAME
                            </th>

                            <th
                                style={{
                                    padding: "16px 24px",
                                    fontSize: "12px",
                                    fontWeight: "600",
                                    color: "#64748b",
                                    width: "50%",
                                    textAlign: "center"
                                }}
                            >
                                PREVIEW
                            </th>

                            <th
                                style={{
                                    padding: "16px 24px",
                                    fontSize: "12px",
                                    fontWeight: "600",
                                    color: "#64748b",
                                    width: "20%",
                                    textAlign: "center"
                                }}
                            >
                                ACTIONS
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {banners.map((banner) => (
                            <tr key={banner.id}>

                                <td
                                    style={{
                                        padding: "20px 24px",
                                        verticalAlign: "middle"
                                    }}
                                >
                                    <div
                                        style={{
                                            fontWeight: 600,
                                            color: "#0f172a"
                                        }}
                                    >
                                        {{
                                            alphabet_mat: "Alphabet Mat",
                                            number_mat: "Number Mat",
                                        }[banner.title] || banner.title}
                                    </div>
                                </td>

                                <td
                                    style={{
                                        padding: "20px 24px",
                                        verticalAlign: "middle",
                                        textAlign: "center"
                                    }}
                                >
                                    <div className="d-flex justify-content-center">
                                        <div
                                            style={{
                                                width: "260px",
                                                height: "120px",
                                                borderRadius: "12px",
                                                overflow: "hidden",
                                                border: "1px solid #e2e8f0",
                                                background: "#fff",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}
                                        >
                                            <img
                                                src={`${banner.banner_url}&v=${imageVersion}`}
                                                alt={banner.title}
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "contain"
                                                }}
                                            />
                                        </div>
                                    </div>
                                </td>

                                <td
                                    style={{
                                        padding: "20px 24px",
                                        verticalAlign: "middle",
                                        textAlign: "center"
                                    }}
                                >
                                    <button
                                        className="btn btn-sm"
                                        onClick={() => handleEdit(banner)}
                                        title="Edit"
                                        style={{
                                            width: "38px",
                                            height: "38px",
                                            borderRadius: "10px",
                                            border: "1px solid #e2e8f0",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "center"
                                        }}
                                    >
                                        <i className="bi bi-pencil"></i>
                                    </button>
                                </td>

                            </tr>
                        ))}
                    </tbody>

                </table>
            </div>

            {/* Modal */}

            {
                showModal && (

                    <div
                        className="modal d-block"
                        style={{
                            background:
                                "rgba(15,23,42,0.55)"
                        }}
                    >

                        <div
                            className="modal-dialog modal-dialog-centered"
                        >

                            <div
                                className="modal-content border-0"
                                style={{
                                    borderRadius: "16px"
                                }}
                            >

                                <div
                                    className="modal-header"
                                    style={{
                                        borderBottom:
                                            "1px solid #e2e8f0",
                                        padding:
                                            "18px 22px"
                                    }}
                                >

                                    <div>

                                        <h5
                                            className="mb-1 fw-semibold"
                                        >

                                            {
                                                editId
                                                    ? "Edit Banner"
                                                    : "Add Banner"
                                            }

                                        </h5>

                                        <p
                                            className="mb-0"
                                            style={{
                                                fontSize:
                                                    "13px",
                                                color:
                                                    "#64748b"
                                            }}
                                        >
                                            Configure banner details
                                        </p>

                                    </div>

                                    <button
                                        className="btn-close"
                                        onClick={resetForm}
                                    />

                                </div>

                                <div
                                    className="modal-body"
                                    style={{
                                        padding:
                                            "22px"
                                    }}
                                >

                                    <div className="mb-3">
                                        <label
                                            className="form-label"
                                            style={{ fontWeight: "500" }}
                                        >
                                            Banner Name
                                        </label>

                                        <select
                                            className="form-control"
                                            name="title"
                                            value={formData.title}
                                            onChange={handleChange}
                                            disabled={!!editId} // Disable the select when editing
                                            style={{
                                                borderRadius: "10px",
                                                height: "46px",
                                            }}
                                        >
                                            <option value="" disabled>
                                                Select Banner
                                            </option>
                                            <option value="Alphabet Mat">Alphabet Mat</option>
                                            <option value="Number Mat">Number Mat</option>
                                        </select>
                                    </div>

                                    {/* <div className="mb-3">

                                        <label
                                            className="form-label"
                                            style={{
                                                fontWeight:
                                                    "500"
                                            }}
                                        >
                                            Sort Order
                                        </label>

                                        <input
                                            type="number"
                                            className="form-control"
                                            name="sort_order"
                                            value={
                                                formData.sort_order
                                            }
                                            onChange={
                                                handleChange
                                            }
                                            style={{
                                                borderRadius:
                                                    "10px",
                                                height:
                                                    "46px"
                                            }}
                                        />

                                    </div> */}

                                    <div className="mb-3">

                                        <label
                                            className="form-label"
                                            style={{
                                                fontWeight:
                                                    "500"
                                            }}
                                        >
                                            Banner Image
                                        </label>

                                        {/* <input
                                            type="file"
                                            className="form-control"
                                            accept="image/*"
                                            onChange={handleFileChange}
                                            style={{
                                                borderRadius: "10px"
                                            }}
                                        /> */}
                                        <Form.Control
                                            type="file"
                                            accept="image/*"
                                            onChange={handleFileChange}
                                            isInvalid={!!errors.banner}
                                            style={{
                                                borderRadius: "10px"
                                            }}
                                        />

                                        <Form.Control.Feedback
                                            type="invalid"
                                            style={{
                                                display: errors.banner ? "block" : "none"
                                            }}
                                        >
                                            {errors.banner}
                                        </Form.Control.Feedback>
                                        <small className="text-muted d-block mt-1">
                                            Recommended Banner size: <strong>2956 × 834 pixels</strong>.
                                        </small>
                                    </div>

                                    {
                                        preview && (

                                            <div
                                                className="mt-3"
                                            >

                                                <img
                                                    src={preview}
                                                    alt="Preview"
                                                    style={{
                                                        width:
                                                            "100%",
                                                        height:
                                                            "220px",
                                                        objectFit:
                                                            "cover",
                                                        borderRadius:
                                                            "12px",
                                                        border:
                                                            "1px solid #e2e8f0"
                                                    }}
                                                />

                                            </div>

                                        )
                                    }

                                </div>

                                <div
                                    className="modal-footer"
                                    style={{
                                        borderTop:
                                            "1px solid #e2e8f0",
                                        padding:
                                            "16px 22px"
                                    }}
                                >

                                    <button
                                        className="btn"
                                        onClick={resetForm}
                                        style={{
                                            border:
                                                "1px solid #e2e8f0",
                                            borderRadius:
                                                "10px",
                                            padding:
                                                "10px 18px"
                                        }}
                                    >
                                        Cancel
                                    </button>

                                    <button
                                        className="btn"
                                        onClick={handleSubmit}
                                        disabled={loading}
                                        style={{
                                            background:
                                                "#0f172a",
                                            color:
                                                "#ffffff",
                                            borderRadius:
                                                "10px",
                                            padding:
                                                "10px 18px"
                                        }}
                                    >

                                        {
                                            editId
                                                ? "Update Banner"
                                                : "Save Banner"
                                        }

                                    </button>

                                </div>

                            </div>

                        </div>

                    </div>

                )
            }

        </div>

    );

};

export default TvApkBanners;